import { styled } from 'styled-components';
import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { Button } from '@lyse-as/formds-react';

import { LargeContainer } from 'src/components/container';
import { Image } from 'src/components/image';
import { breakpointLargeTablet } from 'src/styles/breakpoints';
import { colorPrimary, colorSecondarySurface } from 'src/styles/colors';
import { focus } from 'src/styles/mixins';
import { spacing1 } from 'src/styles/spacing';

export const StyledHeader = styled.header`
  background: ${colorPrimary};
  position: relative;
`;

export const StyledHeaderContainer = styled(LargeContainer)`
  display: flex;
  align-items: center;
  min-height: 72px;
  justify-content: right;
`;

export const StyledLinkText = styled(Typography)`
  font-weight: bold;
  margin-left: ${spacing1};
  height: 24px;
  line-height: 24px;
  font-size: 16px;
  box-sizing: border-box;
  color: inherit;

  &:hover {
    border-bottom: 1px solid ${colorSecondarySurface};
  }
`;

export const StyledLink = styled.a`
  text-decoration: none;
  display: none;
  margin-right: auto;
  color: ${colorSecondarySurface};

  ${focus};

  @media (min-width: ${breakpointLargeTablet}) {
    display: flex;
  }
`;

export const StyledLogo = styled(Image)`
  width: 55px;
  position: absolute;
  inset: 0;
  margin: auto;

  @media (min-width: ${breakpointLargeTablet}) {
    width: 160px;
  }
`;

export const StyledButton = styled(Button)`
  color: ${colorSecondarySurface};
`;
